import React from 'react';
import { Link } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaBehance, FaPhone, FaFax } from "react-icons/fa";


const OffcanvasMenu = ({offcanvasShow, offcanvasHide}) => {
    return (
        <Offcanvas show={offcanvasShow} onHide={offcanvasHide} placement="end" className="header-offcanvasmenu">
            <Offcanvas.Header closeButton></Offcanvas.Header>
            <Offcanvas.Body>
                <form action="#" className="side-nav-search-form">
                    <div className="form-group">
                        <input type="text" className="search-field" name="search-field" placeholder="بحث..." />
                     

                        <button className="side-nav-search-btn"><i className="fas fa-search"></i></button>

                    
                    </div>
                </form>
                <div className="row ">
                    <div className="col-lg-5 col-xl-6">
                        <ul className="main-navigation list-unstyled">
                            <li><Link to={process.env.PUBLIC_URL + "/service-details/تصميم-المواقع-الإلكترونية"}>تصميم المواقع الإلكترونية</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/service-details/تطبيقات-الموبايل"}>تصميم تطبيقات الموبايل</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/service-details/المتاجر-الإلكترونية"}>تصميم المتاجر الإلكترونية</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/service-details/إدارة-إعلانات-جوجل"}>خدمات التسويق الرقمي</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/service-details/إدارة-المحتوى"}>خدمات إدارة المحتوى</Link></li>
                        </ul>
                    </div>
                    <div className="col-lg-7 col-xl-6">
                        <div className="contact-info-wrap">
                            <div className="contact-inner">
                                <address className="address">
                                    <span className="title">معلومات التواصل</span>
                                    <p>دبي<br /> الإمارات العربية المتحدة</p>
                                </address>
                                <address className="address">
                                    <span className="title">متواجدون على مدار الساعة .. اتصل الآن</span>
                                    <a href="tel:0505733543" className="tel"><FaPhone /> 543 5733 (050)</a>
                                </address>
                            </div>
                            <div className="contact-inner">
                                <h5 className="title">تجدني أيضاً هنا</h5>
                                <div className="contact-social-share">
                                    <ul className="social-share list-unstyled">
                                        <li>
                                            <a href="https://facebook.com/"><FaFacebookF /></a>
                                        </li>

                                        <li>
                                            <a href="https://twitter.com/"><FaTwitter /></a>
                                        </li>
                                        <li>
                                            <a href="https://www.behance.net/"><FaBehance /></a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/"><FaLinkedinIn /></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default OffcanvasMenu;
